angular.module('impactx.purchaserequest').controller('CateringDialogRequestItemViewCtrl', CateringDialogRequestItemViewCtrl);

CateringDialogRequestItemViewCtrl.$inject = ['$scope', 'dataGen', '$mdDialog', 'itemId'];

function CateringDialogRequestItemViewCtrl($scope, dataGen, $mdDialog, itemId) {
    var ctrl = this;

    ctrl.participantsEntryPoint = '/purchaserequest/cateringparticipants';

    ctrl.getData = function () {
        var paramObj = {
            itemId: itemId
        };
        dataGen.getData($scope, paramObj, '/purchaserequest/viewcatering');
    };

    ctrl.cancel = function () {
        $mdDialog.cancel();
    }

    ctrl.getData();
}